import { writeJson } from '@wix/cli-fs';
import { getAppManifestPath } from '@wix/cli-app-definitions';
import type { AppManifest } from '@wix/cli-app-manifest';
import { readAppManifest } from '@wix/cli-app-manifest';

export async function writeAppManifestFile({
  projectFolder,
  manifest,
}: {
  projectFolder: string;
  manifest: AppManifest;
}) {
  const manifestPath = getAppManifestPath(projectFolder);

  return writeJson(manifestPath, manifest);
}

export async function readAppManifestFile(projectFolder: string) {
  const manifestPath = getAppManifestPath(projectFolder);

  return readAppManifest(manifestPath);
}
